<template>
    <div class="myHomework commonBackground padding-b-x">
        <div class="title text-l-size border-bottom delFloat">
            我的作业
        </div>
        <div class="secondLine">
            <span class="text-small-secondary">学科：</span>
            <el-button size="small" @click="selectSubject(item.subjectId)"
                       :class="subjectId===item.subjectId?'active':''"
                       class="text-default-color"
                       type="text" v-for="item in subjectList" :key="item.subjectId">
                {{item.subjectName}}
            </el-button>
        </div>
        <div class="secondLine">
            <span class="text-small-secondary">类型：</span>
            <el-button size="small" @click="selectType(item.typeId)"
                       :class="typeId===item.typeId?'active':''"
                       class="text-default-color"
                       type="text" v-for="item in homeTypeList" :key="item.typeId">
                {{item.typeName}}
            </el-button>
        </div>
        <div class="secondLine">
            <el-radio-group v-model="statusId"  size="small"  @change="selectStatus">
                <el-radio-button
                        v-for="item in status"
                        :key="item.status"
                        class="text-ellipsis"
                        :title="item.text"
                        :label="item.status">
                    {{item.text}}
                </el-radio-button>
            </el-radio-group>
        </div>
        <div class="noteLine margin-medium-top position-relative">
            <loading :show="homeworkLoading"></loading>
            <div v-show="homeworkList.length>0&&!homeworkLoading">
                <div>共 <span class="numberColor">{{totalItem}}</span> 条</div>
                <div class="position-relative homeBox padding-x-y border-bottom"
                    v-for="(item,index) in homeworkList" :key="index">
                    <div class="left">
                        <div>
                            <el-tag  size="mini" color="orange"   class="nTag margin-right" effect="dark" v-show="item.typeName==='视频'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" color="red"   class="nTag margin-right" effect="dark" v-show="item.typeName==='混合'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" class="margin-right nTag" effect="dark" v-show="item.typeName==='试卷'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" color="#8BC05D" class="nTag margin-right" effect="dark" v-show="item.typeName==='模拟选科'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" color="#FF705F" class="nTag margin-right" effect="dark" v-show="item.typeName==='计划'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" color="#39CFC3" class="nTag margin-right" effect="dark" v-show="item.typeName==='心理测评'">{{item.typeName}}</el-tag>
                            <el-tag  size="mini" color="#985CF6" class="nTag margin-right" effect="dark" v-show="item.typeName==='多学科'">{{item.typeName}}</el-tag>
                            <span class="margin-right text-m-size">{{item.title}}</span>
                            <el-tag size="mini">
                                {{item.subjectName}}
                            </el-tag>
                        </div>
                        <div class="secondLine delFloat text-small-secondary margin-top">
                            <span>开始时间：{{item.startAt}}</span>
                            <span>截止时间：{{item.deadlineAt}}</span>
                            <span>
                                 布置人：{{item.teacherName}}
                            </span>
                        </div>
                    </div>
                    <div class="position-absolute delFloat right margin-top">
                        <div class="text-left status float-left  margin-medium-right">
                            <span v-show="!item.isCompleted" class="danger">未完成</span>
                            <span v-show="item.isCompleted" class="blue">已完成</span>
                        </div>
                        <div class="float-right  margin-bottom">
                            <el-button size="small" @click="lookView(item)">
                                查看详情
                            </el-button>
                        </div>
                    </div>
                </div>
                <el-pagination
                        background
                        class="margin-top text-center"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalItem">
                </el-pagination>
            </div>
            <empty v-show="!homeworkLoading&&homeworkList.length<1" :text-size="18"
                content="暂无相关作业">
            </empty>
        </div>
    </div>
</template>
<script>
    import {myHomeStuHwList, myHomeStuStatus, myHomeStuType, myHomeSubject} from "../../../config";
    // import  Work  from "../winHolidayWork/winHolidayWork";
    export default {
        name: "myHomework",
        data(){
            return{
                subjectList:[],
                subjectId:null,
                homeTypeList:[],
                typeId:null,
                status:[],
                statusId:'1',
                //查出我的作业内容
                homeworkList:[],
                totalItem:0,
                currentPage:1,
                homeworkLoading:false
            }
        },
        mounted(){
          this.searchStatus();
          this.searchSubject();
          this.searchHomeTopType();
          this.searchHomeworkNote();
        },
        // components: {
        //     Work
        // },
        methods:{
            lookView(val){
                this.$router.push({path:'/sDetail/homeworkDetail',
                    query:{hwId:val.hwId,
                        startAt:val.startAt,
                        deadlineAt:val.deadlineAt,
                        teacherName:val.teacherName}});
            },
            handleCurrentChange(){
                this.searchHomeworkNote();
            },
            //查出学科
            async searchSubject(){
                let result=await myHomeSubject();
                if(result.status){

                    this.subjectList=result.data;
                }
            },
            //查出作业列表上方的类型列表
            async searchHomeTopType(){
                let result=await myHomeStuType();
                if(result.status){
                    this.homeTypeList=result.data;
                }
            },
            //选择学科
            selectSubject(val){
                this.currentPage=1;
                this.subjectId=val;
                this.searchHomeworkNote();
            },
            //选择类型
            selectType(val){
                this.currentPage=1;
                this.typeId=val;
                this.searchHomeworkNote();
            },
            //查出状态
            async searchStatus(){
                let result=await myHomeStuStatus();
                if(result.status){
                    this.status=result.data;
                }
            },
            //选择状态
            selectStatus(){
                this.currentPage=1;

                this.searchHomeworkNote();
            },
            //查出我的作业记录
            async searchHomeworkNote(){
                this.homeworkLoading=true;
                let result=await myHomeStuHwList(this.subjectId,this.typeId,this.statusId,this.currentPage,20);
                if(result.status){
                    this.homeworkLoading=false;
                    if(result.data!==null){
                        this.homeworkList=result.data.data;
                        this.totalItem=result.data.totalRecords;
                    }
                }else{
                    this.homeworkLoading=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .myHomework{
        margin-top: 20px;
        .title{
            line-height: 60px;
            height:60px;
        }
        .secondLine{
            margin-top: 20px;
            span{
                margin-right: 10px;
            }
            .el-button{
                margin-right: 10px;
            }
        }
        .active{
            color: #ffffff!important;
            padding: 5px 10px;
            background: #0a93fc;
        }
        .noteLine{
            min-height: 400px;
            .homeBox{
                .secondLine{
                    margin-top:20px;
                    span{
                        margin-right: 30px;
                    }
                }
                .right{
                    top:20px;
                    right: 0;
                    .status{
                        height:33px;
                        line-height:33px;
                    }
                    .danger{
                        color:orangered;
                    }
                    .blue{
                        color:dodgerblue;
                    }
                }
            }
        }
    }
</style>